<template>
  <div class="ucrs-chartCaption">
    <div v-for="(item, i) in items" :key="i" class="ucrs-chartCaption__item">
      <span
        class="ucrs-chartCaption__square"
        :style="`background-color: ${item.color};`"
      ></span>
      <p>
        <span class="inline-block mr-2 sm:mr-4">{{ item.qt }}%</span>
        <span>{{ item.label }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
}
</script>

<style lang="postcss">
.ucrs-chartCaption {
  @apply text-navitem uppercase font-bold -m-1.2 -my-2 columns-2;

  @screen sm {
    @apply text-sm -mx-8;
  }

  &__item {
    @apply flex items-center px-1.2 py-2 break-inside-avoid-column;

    @screen sm {
      @apply px-8;
    }
  }
  &__square {
    @apply block w-6.4 min-w-6.4 h-6.4 rounded mr-4;
  }
}
</style>
